<template>
  <div class="icon-body">
    <el-input
      v-model="name"
      style="position: relative"
      clearable
      placeholder="请输入图标名称"
      @clear="filterIcons"
      @input="filterIcons"
    >
      <i
        slot="suffix"
        class="el-input__icon el-icon-search icon-search-btn"
        @click="filterIcons"
      />
    </el-input>
    <div class="icon-list">
      <div
        v-for="(item, index) in iconList"
        :key="index"
        @click="selectedIcon(item)"
        class="icon-item"
      >
        <!-- <svg-icon :icon-class="item" style="height: 30px;width: 16px;" /> -->
        <i :class="`fa fa-${item}`" style="width: 16px"></i>
        
        <span>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import icons from "./requireIcons";
export default {
  name: "IconSelect",
  data() {
    return {
      name: "",
      iconList: icons,
    };
  },
  created() {
    this.iconList = icons;
  },
  watch: {
    name() {
      this.filterIcons();
    },
  },
  methods: {
    filterIcons() {
      this.iconList = icons;
      if (this.name) {
        this.iconList = this.iconList.filter((item) =>
          item.includes(this.name)
        );
      }
    },
    selectedIcon(name) {
      this.$emit("selected", name);
      document.body.click();
    },
    reset() {
      this.name = "";
      this.iconList = icons;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.icon-search-btn {
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
.icon-body {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  .icon-list {
    height: 260px;
    overflow-y: auto;
    overflow-x: hidden;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    padding: 4px 0;
    .icon-item {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 36px;
      padding: 0 8px;
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.15s;
      &:hover {
        background: #ecf5ff;
      }
      i {
        font-size: 16px;
        flex-shrink: 0;
        width: 18px;
        text-align: center;
      }
      span {
        flex: 1;
        font-size: $font-size-base;
        color: #606266;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1;
      }
    }
  }
}
</style>
